import { Flex, Text, Textarea } from '@billy/design-system'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useLegalMentionsModalForm } from '../../../../../../../../../../context/legalMentionsModalFormContext'

const TEXT_AREA_ROWS_COUNT = 2
const CUSTOM_MENTION_MAX_TEXT = 250

export const EarlyPaymentDiscountCustomMentionField = () => {
  const { t } = useTranslation()
  const { legalMentionsModalForm } = useLegalMentionsModalForm()
  const { FormItem, control } = legalMentionsModalForm

  const value = useWatch({
    control,
    name: 'custom.earlyPaymentDiscount',
  })

  const length = value?.length ?? 0

  return (
    <FormItem
      name="custom.earlyPaymentDiscount"
      label={
        <Flex alignItems="center" justifyContent="space-between">
          <Text variant="bodyLG" weight="medium">
            {t(
              'settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.custom_mention_field.title',
            )}
          </Text>

          <Text variant="bodySM">
            {length}/{CUSTOM_MENTION_MAX_TEXT}
          </Text>
        </Flex>
      }
      render={({ field }) => (
        <Textarea
          {...field}
          maxLength={CUSTOM_MENTION_MAX_TEXT}
          resizable
          rows={TEXT_AREA_ROWS_COUNT}
          value={field.value ?? ''}
        />
      )}
    />
  )
}
